var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',[_vm._v(_vm._s(_vm.item.category))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.item.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }